// rootReducer.ts
import { combineReducers } from "@reduxjs/toolkit";
import mmRfqFormDataReducer from "./MMRfq/reducer"; // Your reducer
import CoPoReducer from "./CoPo/reducer";

// Combine reducers
const rootReducer = combineReducers({
    mmRfqFormDataReducer: mmRfqFormDataReducer,
    CoPoReducer: CoPoReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
